import { config } from '../config/config';

// Interface pour les détails de paiement
export interface CampayPaymentDetails {
  amount: number;
  votes_count: number;
  phoneNumber: string;
  operator: string;
  contestantId: string;
  description?: string;
  customerName?: string;
  customerEmail?: string;
}

// Interface pour la réponse d'initiation de paiement
export interface CampayPaymentResponse {
  transaction: {
    id: string;
    amount: number;
    status: string;
    payment_method: string;
    payment_reference: string | null;
    payment_url: string | null;
    votes_count: number;
  };
  payment_reference: string;
  payment_url: string;
}

// Interface pour la réponse de statut de paiement
export interface CampayStatusResponse {
  status: 'success' | 'pending' | 'failed';
  data: any;
}

/**
 * Initie un paiement via la fonction Edge Campay
 */
export const initiateCampayEdgePayment = async (
  details: CampayPaymentDetails
): Promise<CampayPaymentResponse> => {
  try {
    const response = await fetch(`${config.supabaseUrl}/functions/v1/campay-proxy/initiate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${config.supabaseKey}`,
      },
      body: JSON.stringify(details),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Échec de l'initiation du paiement");
    }

    return await response.json();
  } catch (error) {
    console.error("Erreur lors de l'initiation du paiement Campay:", error);
    throw error;
  }
};

/**
 * Vérifie le statut d'un paiement via la fonction Edge Campay
 */
export const checkCampayEdgePaymentStatus = async (
  reference: string
): Promise<CampayStatusResponse> => {
  try {
    const response = await fetch(`${config.supabaseUrl}/functions/v1/campay-proxy/status`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${config.supabaseKey}`,
      },
      body: JSON.stringify({ reference }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Échec de la vérification du statut");
    }

    return await response.json();
  } catch (error) {
    console.error("Erreur lors de la vérification du statut Campay:", error);
    throw error;
  }
};
